var map = {
	"./Elective_Term_Application_Letter_Template.docx": "7df4",
	"./Elective_Term_Leave_Application_Form.docx": "1c9e",
	"./Leave_Sept_2023_Version_Application_Form.docx": "6721",
	"./Reports_Word_Document_Template.docx": "f2de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fce1";